import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  computed,
  effect
} from '@angular/core';
import { NzModalComponent, NzModalContentDirective } from 'ng-zorro-antd/modal';
import { NzFormDirective } from 'ng-zorro-antd/form';
import { SEComponent, SEContainerComponent } from '@delon/abc/se';
import { FormsModule } from '@angular/forms';
import { NzSelectComponent } from 'ng-zorro-antd/select';

@Component({
  selector: 'app-field-mapper-modal',
  standalone: true,
  imports: [
    NzModalComponent,
    NzModalContentDirective,
    NzFormDirective,
    SEContainerComponent,
    FormsModule,
    SEComponent,
    NzSelectComponent
  ],
  templateUrl: './field-mapper-modal.component.html',
  styles: `
    .grid-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
    }

    .grid-item {
      width: 150px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldMapperModalComponent {
  data: any = {};
  showFieldMapperModal = input.required<boolean>();
  columns = input.required<any[]>();
  csvHeaders = input<string[]>([]);
  savedMapperData = input<any>({});
  requestSave = output<void>();
  requestClose = output<void>();

  private hasInitialized = false;
  private previousModalState = false;

  csvSelectOptions = computed(() => {
    return this.csvHeaders()?.length
      ? Object.keys(this.csvHeaders()[0] || {}).map(key => ({
          label: key,
          value: key
        }))
      : [];
  });

  private readonly csvOptionsAvailable = computed(() => {
    const options = this.csvSelectOptions();
    return options.length > 0 && this.columns()?.length > 0;
  });

  constructor() {
    effect(() => {
      if (this.csvOptionsAvailable() && !this.hasInitialized) {
        this.setDefaultValues();
        this.hasInitialized = true;
      }
    });
     // Effect to reset data when modal opens
     effect(() => {
      const currentModalState = this.showFieldMapperModal();
      // Detect when modal transitions from closed to open
      if (currentModalState && !this.previousModalState) {
        this.resetData();
      }
      this.previousModalState = currentModalState;
    });
  }

  private resetData(): void {
    // Reset data to either saved mapper data or default values
    const saved = this.savedMapperData();
    if (saved && Object.keys(saved).length > 0) {
      this.data = { ...saved };
    } else {
      this.data = {};
      this.setDefaultValues();
    }
  }

  private setDefaultValues(): void {
    if (!this.columns() || !this.csvHeaders()?.length) return;

    const csvOptions = this.csvSelectOptions();

    this.columns().forEach(column => {
      if (column.index !== 'id' && !column.noMapping) {
        const matchingOption = csvOptions.find(option => {
          return option.label.toLowerCase() === column.index.toLowerCase();
        });
        // If a matching option is found, set the default value
        if (matchingOption) {
          this.data[column.index] = matchingOption.value;
        }
      }
    });
  }


}
